import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Annulation } from '../models/Annulation';
@Component({
	selector: 'app-annulation',
	templateUrl: './annulation.component.html'
})
export class AnnulationComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'Annulation';
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() annulation: Annulation;

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
